export default "/_next/static/images/ft-logo-5f22904b38cbd62a8cfc662971d50eeb.png";